var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNokiaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#nokia_icon_svg__clip0_3859_8771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0V0z",
    fill: "#005AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.049.869v14.235h2.31V5.696l12.012 9.855v-2.952L1.049.87z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "nokia_icon_svg__clip0_3859_8771"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM4NTlfODc3MSkiPgo8cGF0aCBkPSJNMCAwSDE2VjE2SDBWMFoiIGZpbGw9IiMwMDVBRkYiLz4KPHBhdGggZD0iTTEuMDQ4NTggMC44Njg5MjdWMTUuMTA0MUgzLjM1OTg5VjUuNjk2NDlMMTUuMzcwNyAxNS41NTA2VjEyLjU5OTNMMS4wNDg1OCAwLjg2ODkyN1oiIGZpbGw9IndoaXRlIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMzg1OV84NzcxIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgNokiaIcon as ReactComponent };